import { render, staticRenderFns } from "./CreateStudio.vue?vue&type=template&id=20a36b17"
import script from "./CreateStudio.vue?vue&type=script&lang=ts"
export * from "./CreateStudio.vue?vue&type=script&lang=ts"
import style0 from "./CreateStudio.vue?vue&type=style&index=0&id=20a36b17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports